const state = {
  industry: null,
  industry_params: null,
  marketArea: null,
  salesClass: null,
  type: "Industry firms",
  years: 5,
  favoriteIndustries: [],
  favoriteMarketAreas: [],
  favoriteSalesClasses: [],
  searchInputIndustry: null,
  searchInputMarketArea: null,
  searchIndustries: [],
  searchMarketAreas: [],
  searchLoadingIndustry: false,
  searchLoadingMarketArea: false,
  profileId: 0,
};

const mutations = {
  SET_INDUSTRY: (state, industry) => {
    state.industry = industry;
  },
  SET_INDUSTRY_PARAMS: (state, params) => {
    state.industry_params = params;
  },
  SET_MARKET_AREA: (state, marketArea) => {
    state.marketArea = marketArea;
  },
  SET_SALES_CLASS: (state, salesClass) => {
    state.salesClass = salesClass;
  },
  SET_TYPE: (state, type) => {
    state.type = type;
  },
  SET_YEARS: (state, years) => {
    state.years = years;
  },
  SET_PROFILE_ID: (state, profileId) => {
    state.profileId = profileId;
  },
  SET_FAVORITE_INDUSTRIES: (state, industry) => {
    state.favoriteIndustries = industry;
  },
  SET_FAVORITE_MARKET_AREAS: (state, marketArea) => {
    state.favoriteMarketAreas = marketArea;
  },
  SET_FAVORITE_SALES_CLASSES: (state, salesClass) => {
    state.favoriteSalesClasses = salesClass;
  },
  SET_SEARCH_INPUT_INDUSTRY: (state, searchInputIndustry) => {
    state.searchInputIndustry = searchInputIndustry;
  },
  SET_SEARCH_INPUT_MARKET_AREA: (state, searchInputMarketArea) => {
    state.searchInputMarketArea = searchInputMarketArea;
  },
  SET_SEARCH_INDUSTRIES: (state, searchIndustries) => {
    state.searchIndustries = searchIndustries;
  },
  SET_SEARCH_MARKET_AREAS: (state, searchMarketAreas) => {
    state.searchMarketAreas = searchMarketAreas;
  },
  SET_SEARCH_LOADING_INDUSTRY: (state, searchLoadingIndustry) => {
    state.searchLoadingIndustry = searchLoadingIndustry;
  },
  SET_SEARCH_LOADING_MARKET_AREA: (state, searchLoadingMarketArea) => {
    state.searchLoadingMarketArea = searchLoadingMarketArea;
  },
  PUSH_TO_FAVORITE_INDUSTRIES: (state, industry) => {
    if(state.favoriteIndustries === undefined) { state.favoriteIndustries = []; } // TODO: This is the wrong way to do this.
    state.favoriteIndustries.push(industry);
  },
  PUSH_TO_FAVORITE_MARKET_AREAS: (state, marketArea) => {
    state.favoriteMarketAreas.push(marketArea);
  },
  PUSH_TO_FAVORITE_SALES_CLASSES: (state, salesClass) => {
    state.favoriteSalesClasses.push(salesClass);
  },
};

const getters = {
  industry: (state) => state.industry,
  industry_params: (state) => state.industry_params,
  marketArea: (state) => state.marketArea,
  salesClass: (state) => state.salesClass,
  type: (state) => state.type,
  years: (state) => state.years,
  profileId: (state) => state.profileId,
  favoriteIndustries: (state) => state.favoriteIndustries,
  favoriteMarketAreas: (state) => state.favoriteMarketAreas,
  favoriteSalesClasses: (state) => state.favoriteSalesClasses,
  searchInputIndustry: (state) => state.searchInputIndustry,
  searchInputMarketArea: (state) => state.searchInputMarketArea,
  searchIndustries: (state) => state.searchIndustries,
  searchMarketAreas: (state) => state.searchMarketAreas,
  searchLoadingIndustry: (state) => state.searchLoadingIndustry,
  searchLoadingMarketArea: (state) => state.searchLoadingMarketArea,
};

const selection = {
  state,
  getters,
  mutations,
};

export default selection;
